import React, { useState, useEffect } from 'react';
import { FaShieldAlt, FaVideo, FaCar, FaHandshake } from 'react-icons/fa';
import { getAdvantages } from '../services/api';

const iconMap = {
  guarantee: <FaShieldAlt className="text-3xl text-red-500" />,
  online: <FaVideo className="text-3xl text-blue-500" />,
  free: <FaCar className="text-3xl text-green-500" />,
  noBrokerage: <FaHandshake className="text-3xl text-purple-500" />,
};

const bgMap = {
  guarantee: 'bg-red-50',
  online: 'bg-blue-50',
  free: 'bg-green-50',
  noBrokerage: 'bg-purple-50',
};

const WhyChooseUs = () => {
  const [advantages, setAdvantages] = useState([]);

  useEffect(() => {
    getAdvantages().then(data => setAdvantages(data || []));
  }, []);

  return (
    <section className="py-10 bg-white relative z-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-red-500 text-sm font-semibold uppercase tracking-wider">ADVANTAGES</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mt-2">Why Choose Us?</h2>
          <p className="text-gray-500 mt-3 max-w-xl mx-auto">
            Discover the key advantages of investing with us.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {advantages.map((item, idx) => (
            <div
              key={idx}
              className={`${bgMap[item.icon] || 'bg-gray-50'} rounded-2xl p-6 text-center hover:shadow-lg transition-shadow duration-300 group cursor-pointer`}
            >
              <div className="w-16 h-16 mx-auto mb-4 bg-white rounded-2xl flex items-center justify-center shadow-sm group-hover:scale-110 transition-transform">
                {iconMap[item.icon]}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
